<template>
  <div>
    <div class="card" v-for="(item, index) in tests" :key="index">
      <img v-lazy="item.evaluation.classify_image" class="testImg" />
      <div class="detail">
        <p class="h2">{{ item.evaluation.title }}</p>
        <p>
          <b class="watch" @click="gotoDetail(item)">查看</b>
          <span v-if="item.finish_time" class="right">{{
            item.finish_time.slice(0, 10)
          }}</span>
          <span v-else class="right">{{ item.created_at.slice(0, 10) }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import store from "./../store/index";
export default {
  name: "FinishList",
  props: {
    tests: Array,
    type: Boolean,
  },
  data() {
    return {};
  },
  watch: {
    item(val) {
      this.item = val;
    },
    type(val) {
      this.type = val;
    },
  },
  methods: {
    // 跳转测评详情页
    gotoDetail(item) {
      // console.log(this.type)
      if (this.type) {
        if (item.is_finished.key == "finished") {
          // console.log(item);
          let id = item.evaluation.id;
          store.commit("set_eval_id", item.evaluation.id);
          store.commit("set_appraisal_id", item.id);
          this.$router.push("/test/" + id + "/introduction");
        } else {
          let id = item.evaluation.id;
          store.commit("set_eval_id", item.evaluation.id);
          store.commit("set_appraisal_id", item.id);
          this.$router.push("/test/" + id + "/gender");
        }
      } else if (!this.type) {
        let id = item.evaluation.id;
        store.commit("set_eval_id", item.evaluation.id);
        store.commit("set_appraisal_id", item.id);
        this.$router.push("/test/" + id + "/result");
      }
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.card {
  width: 100%;
  margin: 12px 0 0 11px;

  .testImg {
    width: 32%;
    border-radius: 12px;
    margin: 10px;
    height: 96px;
  }

  .status {
    width: 30%;
    margin-top: -1rem;
    margin-left: 10px;
    color: white;
    font-weight: bold;

    p {
      margin-left: 10px;
      margin-bottom: 5px;
    }

    .process {
      width: 100%;
      height: 5px;
      background-color: orange;
      position: relative;
      border-radius: 0 0 5px 5px;
    }
  }

  .detail {
    float: right;
    width: 212px;
    margin-right: 23px;
    font-size: 15px;
    margin-top: 20px;

    .h2 {
      height: 1.6rem;
      line-height: 0.6rem;
    }

    .watch {
      display: inline-block;
      width: 78px;
      height: 20px;
      background: #42686e;
      border-radius: 8px;
      font-size: 13px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 20px;
      letter-spacing: 1px;
    }

    .discount {
      color: gray;
      font-size: smaller;
    }

    .right {
      float: right;
      margin-right: 10px;
      font-size: 12px;
      margin-top: 6px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #4a4a4a;
    }
  }
}

.icons {
  /* width: 80%; */
  margin-top: -30px;
  margin-left: 15%;
  margin-right: 15%;
  height: 50px;
  position: relative;
  border-radius: 15px;
  background: white;

  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;
  /* 垂直居中 */
}
</style>
